import { FC } from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

interface Props {
  percent: number;
  size?: number;
  strokeWidth?: number;
  children?: React.ReactNode;
}

export const CircleProgressIcon: FC<React.PropsWithChildren<Props>> = ({ percent, size = 32, strokeWidth = 2.6, children }) => {
  const progress = percent / 100;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const dashoffset = circumference * (1 - progress);

  return (
    <Root size={size}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} fill='none'>
        <circle className='frame' cx={size / 2} cy={size / 2} r={radius} stroke-width={strokeWidth} fill='none' />
        <circle
          className='progress'
          cx={size / 2}
          cy={size / 2}
          fill='none'
          r={radius}
          stroke-width={strokeWidth}
          strokeDashoffset={dashoffset}
          strokeDasharray={circumference}
        />
      </svg>
      {children}
    </Root>
  );
};

const Root = styled.div<{ size: number }>`
  position: relative;
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  margin-left: 16px;

  svg {
    transform: rotate(-90deg);
  }
  .frame {
    stroke: ${vars.v3Color.gray200};
  }
  .progress {
    stroke: ${vars.v3Color.skyBlue300};
    stroke-linecap: round;
  }
`;
